import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import { checkSession } from "../globalStore/slices/user/userSlice";
import { init } from "../globalStore/slices/organization/organizationSlice";
import { initAssetHistory } from "../globalStore/slices/assetHistory/thunks/init";
import { initAssets } from "../globalStore/slices/assets/thunks/init";
import { initDevices } from "../globalStore/slices/devices/devicesSlice";
import { initInventory } from "../globalStore/slices/inventory/thunks/init";
import { initInventoryHistory } from "../globalStore/slices/inventoryHistory/thunks/init";
import { initSettings } from "../globalStore/slices/settings/thunks/init";
import { LicenseInfo } from "@mui/x-license-pro";
import { Box, Grow, CssBaseline } from "@mui/material";
import { StyledEngineProvider } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { ThemeContextProvider } from "../context/ThemeContext";
import AuthContainer from "./auth";
import lxlogobluegreen from "./../assets/lxlogobluegreen.png";
import NoAuthContainer from "./noAuth";

export default function App() {
  const classes = {
    container: {
      display: "flex",
      height: "100vh",
      alignItems: "center",
      justifyContent: "center",
    },
    icon: {
      maxWidth: "300px",
    },
  }
  const [auth, setAuth] = useState({
    isInitializing: true,
    isAuthed: false,
  });

  const dispatch = useDispatch();

  // MUI X Premium license (renew in MUI Store / account when expired)
  LicenseInfo.setLicenseKey(
    "18cb9fcbe877897214af132c6bc9e8ceTz0xMjc3OTYsRT0xODA2Nzk2Nzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y"
  );


  // first render, check session and update store with user data, then dispatch init thunk to organization slice and update store with organization data
  useEffect(() => {
    dispatch(checkSession(localStorage.getItem("token"))).then((res) => {
      if (res.payload?.success) {
        dispatch(init()).then((res) => {
          // dispatching other initializors for our store.
          dispatch(initDevices());
          dispatch(initAssets());
          dispatch(initInventory());
          dispatch(initAssetHistory());
          dispatch(initInventoryHistory());
          dispatch(initSettings());

          // after one second, ending intialization sequence and reporting whether the user's session is valid (isAuthed)
          setTimeout(() => {
            setAuth({
              isInitializing: false,
              isAuthed: res?.payload?.success || false,
            });
          }, 1000);
        });
      } else {
        setTimeout(() => {
          setAuth({ isInitializing: false, isAuthed: false });
        }, 1000);
      }
    });
  }, [dispatch]);

  const { isInitializing, isAuthed } = auth;

  return (
    <StyledEngineProvider injectFirst>
      <ThemeContextProvider>
        <CssBaseline />
        {isInitializing ? (
          <Box sx={classes.container}>
            <Grow
              in={isInitializing}
              style={{ transformOrigin: "0 0 0 0" }}
              timeout={1000}
            >
              <img src={lxlogobluegreen} style={classes.icon} alt="LocatorX launch logo" />
            </Grow>
          </Box>
        ) : (
          <Router>
            {isAuthed ? (
              <>
                <AuthContainer setAuth={setAuth} />
              </>
            ) : (
              <NoAuthContainer setAuth={setAuth} />
            )}
          </Router>
        )}
      </ThemeContextProvider>
    </StyledEngineProvider>
  );
}
